import React from 'react'
import '../../styles/manager/student-info-box.css'
import { Progress } from '@mantine/core'

const StudentInfoCard = ({ name, level, progress, avatar }) => {
  return (
    <div className="card-container">
      <div className="info-box-avatar"> {avatar}</div>
      <div className="info-box-name">{name}</div>
      <div className="info-box-level">Level {level}</div>
      <div className="info-box-progress">
        <Progress color="#0d2a4f" radius="xl" size="lg" value={progress} />
        <div className="info-box-value">{progress}%</div>
      </div>
    </div>
  )
}

export default StudentInfoCard
